import { Num, Obj, Str } from '@livecontrol/core-utils';
import jwtDecode from 'jwt-decode';

export interface MasqueradeToken {
  roleId: number;
  accountId: number;
  userId: number;
  timestamp: number;
  jwt: MasqueradeToken.JWT;
}

export namespace MasqueradeToken {
  export type JWT = string;

  /**
   * Decode the specified masquerade token.
   *
   * @param value - JWT to be decoded.
   * @returns Decoded token
   */
  export const decode = (value?: unknown): MasqueradeToken | undefined => {
    const jwt = Str.normalize(value);

    let token;

    if (jwt) {
      try {
        const obj = jwtDecode<Obj.Rec>(jwt);

        const candidate = {
          roleId: Num.normalize(obj.role_id),
          accountId: Num.normalize(obj.account_id),
          userId: Num.normalize(obj.user_id),
          timestamp: Num.normalize(obj.iat),
          jwt
        };

        if (Obj.isHydrated(candidate)) {
          token = candidate;
        }
      } catch {
        // ignore
      }
    }

    return token;
  };
}
